// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36TlL","footer":"styles_footer__1pgrt","passCodeTooltip":"styles_passCodeTooltip__3lVwo"};